
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ParteProps } from '../../interfaces/recepcion/ParteInterface';

import { AgregarPartesIrregularParams, BuscarIrregularParams, BuscarIrregularResponse, defaultGenerarCaratulaIrregular, defaultIrregularResponse, GenerarCaratulaIrregularResponse } from '../../interfaces/recepcion/IrregularInterface';

export const BuscarIrregular = ( params: BuscarIrregularParams ) => {

    return new Promise<BuscarIrregularResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Irregular/BuscarIrregular', params, token)
            .then( ({ data } : { data : BuscarIrregularResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultIrregularResponse });
            });

        }

    });

}

export const GenerarCaratulaIrregular = ( idIrregular: number ) => {

    return new Promise<GenerarCaratulaIrregularResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Irregular/GenerarCaratula/${ idIrregular }`, token)
            .then( ({ data } : { data : GenerarCaratulaIrregularResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarCaratulaIrregular, message: error.message } );
            });

        }

    });

}

export const EliminarCaratulaIrregular = ( idIrregular: number ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Irregular/EliminarCaratula/${ idIrregular }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPartesIrregular = ( id: number ) => {

    return new Promise<ParteProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Irregular/ObtenerPartesIrregular/${ id }`, token)
            .then( ({ data } : { data : ParteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPartesIrregular = ( params: AgregarPartesIrregularParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Irregular/AgregarPartesIrregular', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
